import { Component, OnInit } from "@angular/core";
import { MatDialog, MatTableDataSource } from "@angular/material";
import { Router, NavigationStart } from "@angular/router";
import { interval, Subscription } from "rxjs";
import { SPORT_FILTER_OPTIONS } from "src/_constants/bet_filters";
import { ConvertUpochToDate } from "src/_helpers/utils";
import { EventDetails, OpenBet, Providers } from "src/_models";
import { MarketRisk, eventRiskAnalysisReport } from "src/_models/market_risk";
import { AppService } from "src/_services/app.service";
import { EventService } from "src/_services/event.service";
import { UserBookComponent } from "./user-book/user-book.component";

type RiskFilters = {
  selectedProviderID: string;
  selectedSportID: string;
  selectedEventID: string;
  selectedMarketID: string;
};

@Component({
  selector: "app-market-risk",
  templateUrl: "./market-risk.component.html",
  styleUrls: ["./market-risk.component.scss"],
})
export class MarketRiskComponent implements OnInit {
  providers: Providers;
  sports:any = SPORT_FILTER_OPTIONS;
  competitions: any[];
  events: EventDetails[];
  eventsList: eventRiskAnalysisReport[];
  selectedEvent: EventDetails;
  panelOpenState = false;
  openBets: MatTableDataSource<OpenBet>;
  mySubscription: Subscription;
  dropdownSettings: any = {};

  filters: RiskFilters = {
    selectedProviderID: "Exchange",
    selectedSportID: "all",
    selectedEventID: "all",
    selectedMarketID: "all",
  };

  constructor(
    private appService: AppService,
    private eventService: EventService,
    public dialog: MatDialog,
    public router: Router
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.mySubscription.unsubscribe();
      }
    });
  }

  ngOnInit() {
    this.sports = this.sports.map((sport) => {
      return {
        id: sport.id,
        name: sport.name
      };
    });    
    this.dropdownSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.getMarketRisk();
  }

  // getOurProviders() {
  //   try {
  //     this.appService.getOurProviders().subscribe((res) => {
  //       if (res.status === "RS_OK") {
  //         this.providers = res.providers;
  //       } else {
  //         if (res.errorDescription === "Invalid Token!") {
  //           sessionStorage.clear();
  //           // this.router.navigateByUrl("/login");
  //         }
  //       }
  //     });
  //   } catch (err) {}
  // }

  getEventRiskDetails() {
    if (this.filters.selectedProviderID) {
      if (this.openBets && this.openBets.data) {
        this.mySubscription = interval(10000).subscribe((x) => {
          // this.getMarketRisk();
          this.getOpenBets();
        });
      }
    }

    // this.getMarketRisk();
    this.getOpenBets();
  }

  getMarketRisk() {
    try {
      this.appService
        .getOperatorRisk(
          this.filters.selectedProviderID,
          this.filters.selectedSportID
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.eventsList = res.events;
            // console.log(this.markets);
          }
        });
    } catch (err) {}
  }

  getOpenBets() {
    try {
      this.eventService
        .eventOpenBets(
          this.filters.selectedProviderID,
          this.filters.selectedSportID,
          this.filters.selectedEventID
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            // this.openBets = res.openBets;
            this.openBets = new MatTableDataSource(res.openBets);
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              // this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }

  onChangeFilters = (key: string, value: any) => {
    console.log("value",value);
    switch (key) {
      case "provider":
        this.selectedEvent = null;
        this.filters.selectedProviderID = value;
        this.filters.selectedEventID = "all";
        // this.getMarketRisk(value, "");
        break;
      case "sport":
        this.selectedEvent = null;

        this.filters.selectedSportID = value.id;
        this.filters.selectedEventID = "all";
        this.getMarketRisk();
        // this.getCompetitions(
        //   this.filters.selectedProviderID,
        //   this.filters.selectedSportID
        // );
        break;

      case "event":
        this.selectedEvent = null;
        this.selectedEvent = this.events.find((event: EventDetails) => {
          return event.eventId === value;
        });

        this.filters.selectedEventID = value;
        this.getEventRiskDetails();
        // getMarketData = (pid: string, sid: string, eid: string) => {
        break;
    }
  };

  isHaveOpenBets = (marketId: string) => {
    if (this.openBets && this.openBets.data) {
      for (let op of this.openBets.data) {
        if (op.marketId === marketId) {
          return false;
        }
      }
    }

    return true;
  };

  convertUpochToDate(date: number) {
    return ConvertUpochToDate(date);
  }

  onClickUserRiskHandler(marketId: string) {
    this.dialog.open(UserBookComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        userBookInfo: {
          providerId: this.filters.selectedProviderID,
          sportId: this.filters.selectedSportID,
          eventId: this.filters.selectedEventID,
          marketId: marketId,
        },
      },
    });
  }

  onRedirectToEventRiskPage(eventData: any) {
    this.router.navigateByUrl(
      `/reports/risk_analysis/${this.filters.selectedProviderID}/${eventData.sportId}/${eventData.eventId}`
    );
  }
}
